/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 13/1/2021
 * @Example
 */
import React, {useState, useEffect, useRef, memo}                                       from 'react';
import Modal                                                                            from '../modal/modal';
import ButtonGeneral                                                                    from "../button/button-general";
import Config                                                                           from '../../../config/index';
import {FormGroup, Row, Col}                                                            from "react-bootstrap";
import * as generalActions
                                                                                        from '../../../redux/general/general_actions';
import SearchIcon
                                                                                        from '@material-ui/icons/Search';
import {FormLabel as Label, TextField, IconButton, Typography, Divider, InputAdornment} from "@material-ui/core";
import {Column}      from "devextreme-react/data-grid";
import GridContainer
                     from "../../grid-container/grid-container";
import {useDispatch} from 'react-redux';
import {LoadPanel}   from "devextreme-react";
import PropTypes     from 'prop-types';
import Checkbox      from "@material-ui/core/Checkbox";

const PopupEmployees        = memo((props) => {
    const {FormID, valueExpr, displayExpr, isOpenCombo, title, onCloseEmployees, width, height, autoSearch} = props;
    const [loading, setLoading]                                                         = useState(false);
    const [selectedRowKeys, setSelectedRowKeys]                                         = useState([]);
    const [dataSource, setDataSource]                                                   = useState([{
        rows:  [],
        total: 0
    }]);
    const [searchValue, setSearchValue]                                                 = useState('');
    const [oldData, setOldData]                                                         = useState([]);
    const [limit, setLimit]                                                             = useState(30);
    const [skip, setSkip]                                                               = useState(0);
    const [isShowChecked, setIsShowChecked]                                             = useState(false);

    const changePage         = useRef(false);
    const tmpSelectedRowKeys = useRef([]);
    const tmpSelectedRowData = useRef([]);
    const isFirst            = useRef(true);
    const dataGrid           = useRef(null);
    const tmpDataSource           = useRef({
        rows:  [],
        total: 0
    });
    const searchTimeout = useRef(null);

    const dispatch = useDispatch();

    useEffect(() => {
        let dataFilter = [...props.data];
        let key        = dataFilter.map(rs => rs[valueExpr]);
        setOldData(dataFilter.map(rs => ({...rs})));
        setTimeout(() => {
            setSelectedRowKeys(key);
        }, 50);
        tmpSelectedRowKeys.current = key;
        tmpSelectedRowData.current = dataFilter;
        isFirst.current = true;
        if (isShowChecked) {
            setDataSource({rows: dataFilter ?? [], total: dataFilter?.length ?? 0});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data]);

    useEffect(() => {
        loadCboEmployees();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skip, limit]);

    function loadCboEmployees (isSearch, searchVal = '') {
        if (isSearch) {
            setSkip(0);
            changePage.current = true;
            isFirst.current = true;
        }
        let param = {
            HostID:   "",
            Type:     "EmployeeID",
            FormID:   FormID,
            Language: Config.language || '84',
            skip:     isSearch ? 0 : skip,
            limit:    limit,
            search:   autoSearch ? searchVal : searchValue,
            // search2: isShowChecked ? tmpSelectedRowKeys.current.join(';') : ''
        };
        setLoading(true);
        dispatch(generalActions.getCboEmployees(param, (error, data) => {
            if (error) {
                Config.popup.show("ERROR", error);
                return false;
            }
            setLoading(false);
            tmpDataSource.current = data;
            if (!isShowChecked) {
                setDataSource(data);
            }
        }));
    }

    function onChangePage (page) {
        changePage.current = true;
        setSkip(page * limit)
    }

    function onChangePerPage (perPage) {
        changePage.current = true;
        setSkip(0);
        setLimit(perPage);
    }

    function setSelected (e, cb) {
        const keyExpr                  = valueExpr;
        const currentSelectedRowKeys   = e.selectedRowsData;
        const currentDeselectedRowKeys = e.currentDeselectedRowKeys;
        if (currentDeselectedRowKeys.length > 0) {
            if (!isFirst.current) {
                tmpSelectedRowData.current = tmpSelectedRowData.current.filter((rs) => {
                    return currentDeselectedRowKeys.indexOf(rs[keyExpr]) < 0;
                });
                tmpSelectedRowKeys.current = tmpSelectedRowKeys.current.filter((rs) => {
                    return currentDeselectedRowKeys.indexOf(rs) < 0;
                });
                if (cb) cb(tmpSelectedRowKeys.current);
            } else {
                if (cb) cb(tmpSelectedRowKeys.current);
            }
        } else if (currentSelectedRowKeys.length > 0) {
            if (isFirst.current) {
                if (tmpSelectedRowData.current.length > 0) {
                    currentSelectedRowKeys.forEach((val) => {
                        if (tmpSelectedRowKeys.current.indexOf(val[keyExpr]) < 0) {
                            tmpSelectedRowKeys.current.push(val[keyExpr]);
                            tmpSelectedRowData.current.push(val);
                        }
                    });
                } else {
                    tmpSelectedRowData.current = currentSelectedRowKeys;
                    currentSelectedRowKeys.forEach(rs => {
                        tmpSelectedRowKeys.current.push(rs[keyExpr]);
                    });
                }
                isFirst.current = false;
            } else {
                currentSelectedRowKeys.forEach((val) => {
                    if (tmpSelectedRowKeys.current.indexOf(val[keyExpr]) < 0) {
                        tmpSelectedRowData.current.push(val)
                        tmpSelectedRowKeys.current.push(val[keyExpr]);
                    }
                });
                isFirst.current = false;
            }
            if (cb) cb(tmpSelectedRowKeys.current)
        }
    };

    function onSelectionChanged (e) {
        const {selectionMode} = props;
        if (changePage.current) {
            setSelectedRowKeys(tmpSelectedRowKeys.current);
            changePage.current = false;
            isFirst.current    = false;
        } else {
            if (selectionMode === 'single') {
                const selectedRowsData         = e.selectedRowsData;
                const currentDeselectedRowKeys = e.currentDeselectedRowKeys;
                if (currentDeselectedRowKeys.length > 0) {

                } else if (selectedRowsData.length > 0) {
                    selectedRowsData.forEach((val) => {
                        tmpSelectedRowData.current = [val]
                        tmpSelectedRowKeys.current = [val[valueExpr]];
                    });
                }
                setSelectedRowKeys(tmpSelectedRowKeys.current);
            } else {
                setSelected(e, (data) => {
                    setSelectedRowKeys(data);
                });
            }
        }
    }

    const onShowSelected = () => {
        if (isShowChecked) {
            setLimit(30);
            setSkip(0);
        }
        setIsShowChecked(!isShowChecked);
        changePage.current = true;
        setSelectedRowKeys(tmpSelectedRowKeys.current);
    };

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [selectedRowKeys]);

    useEffect(() => {
        if (isOpenCombo) {
            setSearchValue('');
            setLimit(30);
            setSkip(0);
            setIsShowChecked(false);
            loadCboEmployees();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title]);

    useEffect(() => {
        const _data = isShowChecked ? {rows: tmpSelectedRowData.current, total: tmpSelectedRowData.current.length} : tmpDataSource.current;
        setDataSource(_data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShowChecked]);

    const handleChangeSearchValue = (value) => {
        setSearchValue(value);
        if (autoSearch) {
            if (searchTimeout.current) {
                clearTimeout(searchTimeout.current);
            }
            searchTimeout.current = setTimeout(() => {
                loadCboEmployees(true, value);
            }, 700);
        }
    };

    function onContentReady(e) {
        setTimeout(() => {
            const selectedRowKeys = dataGrid.current?.instance.getSelectedRowKeys();
            if (JSON.stringify(selectedRowKeys) === JSON.stringify(tmpSelectedRowKeys.current) && changePage.current) {
                changePage.current = false;
            }
        }, 50);
    };

    return (
        <Modal open={isOpenCombo}
               fullWidth={true}
               maxWidth={width}

        >
            <Modal.Title disableTypography>
                <div className={"display_row align-center align-between flex-wrap"} style={{width: "100%"}}>
                    <div className={"display_row align-center"}>
                        <Typography variant="h6" className={"mgr10"}>{Config.lang(title)}</Typography>
                    </div>
                    <div>
                        <ButtonGeneral name={Config.lang('Dong1')}
                                       typeButton={'cancel'}
                                       disabled={loading}
                                       className={"mgr5"}
                                       style={{textTransform: 'uppercase'}}
                                       size={"large"}
                                       onClick={() => onCloseEmployees(false, title, oldData)}/>
                        <ButtonGeneral name={Config.lang('Chon')}
                                       color={"primary"}
                                       variant={"contained"}
                                       loading={loading}
                                       style={{textTransform: 'uppercase'}}
                                       size={"large"}
                                       onClick={() => onCloseEmployees(true, title, tmpSelectedRowData.current)}/>
                    </div>
                </div>
            </Modal.Title>
            <Divider/>
            <Modal.Content>
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={{
                        my: 'center',
                        of: "#root"
                    }}
                    visible={loading}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                />
                <FormGroup>
                    <Row>
                        <Col xs={12} sm={12} md={6} lg={6}>
                            <Label className={"mgr5"}
                                   style={{paddingBottom: 10}}>{Config.lang("Tim_kiem")} {Config.lang(title)}</Label>
                            <TextField
                                variant={"outlined"}
                                fullWidth
                                placeholder={Config.lang("Tim_kiem")}
                                value={searchValue}
                                onChange={(e) => handleChangeSearchValue(e.target.value)}
                                onKeyUp={(e) => !autoSearch && e.keyCode === 13 && loadCboEmployees(true)}
                                InputProps={{
                                    endAdornment: (
                                                      <InputAdornment position="start">
                                                          <IconButton disabled={false}
                                                                      aria-label="search"
                                                                      style={{marginRight: -21}}
                                                                      onClick={() => loadCboEmployees(true)}>
                                                              <SearchIcon/>
                                                          </IconButton>
                                                      </InputAdornment>
                                                  ),
                                }}
                            />
                        </Col>
                    </Row>
                </FormGroup>
                <GridContainer
                    reference={ref => dataGrid.current = ref}
                    totalItems={dataSource.total}
                    itemPerPage={limit}
                    skipPerPage={skip}
                    listPerPage={[30, 45, 60]}
                    dataSource={dataSource.rows}
                    disabled={false}
                    keyExpr={valueExpr}
                    gridProps={{
                        style: {
                            minHeight: 400,
                        }
                    }}
                    showBorders={false}
                    columnAutoWidth={true}
                    pagerFullScreen={false}
                    allowColumnResizing={true}
                    rowAlternationEnabled={true}
                    height={height}
                    selection={{
                        allowSelectAll:     true,
                        mode:               "multiple",
                        selectAllMode:      "allPages",
                        showCheckBoxesMode: "always"
                    }}
                    selectedRowKey={selectedRowKeys}
                    onChangePage={onChangePage}
                    onChangePerPage={onChangePerPage}
                    onSelectionChanged={onSelectionChanged}
                    onContentReady={onContentReady}
                >
                    <Column
                        dataField={'UserPictureURL'}
                        caption={''}
                        cellRender={e => (
                            <img alt=""
                                 src={Config.getUserPicture(e.data.UserPictureURL, require('../../../assets/images/general/user_default.svg'))}
                                 style={{
                                     width:        30,
                                     height:       30,
                                     objectFit:    'cover',
                                     borderRadius: 50
                                 }}/>
                        )}
                    />
                    <Column
                        dataField={valueExpr}
                        caption={Config.lang("Ma")}
                    />
                    <Column
                        caption={Config.lang("Ten")}
                        dataField={displayExpr}
                    />
                </GridContainer>
                <div className="center-row cursor-pointer" style={{ width: 'fit-content' }}
                    onClick={onShowSelected}>
                    <Checkbox
                        checked={isShowChecked}
                    />
                    {Config.lang("Hien_thi_cac_du_lieu_da_chon")}
                </div>
            </Modal.Content>
        </Modal>
    )
});
PopupEmployees.defaultProps = {
    selectionMode: "multiple",
    width:         'md',
    height:        'calc(100vh - 300px)',
    valueExpr:     "UserID",
    displayExpr:   "Fullname",
    autoSearch:    false,
};
PopupEmployees.propTypes    = {
    width:       PropTypes.oneOf(['xs', 'md', 'lg']),
    valueExpr:   PropTypes.string,
    displayExpr: PropTypes.string,
    FormID:      PropTypes.string.isRequired,
    autoSearch:  PropTypes.bool,
};
export default PopupEmployees;